const Home = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99149 19.8943V17.1342C9.99148 16.4322 10.5638 15.8617 11.2729 15.857H13.8704C14.5829 15.857 15.1605 16.4288 15.1605 17.1342V17.1342V19.9028C15.1603 20.4989 15.6408 20.986 16.2427 21H17.9744C19.7006 21 21.1 19.6146 21.1 17.9056V17.9056V10.0541C21.0908 9.38174 20.7719 8.75041 20.2342 8.33973L14.3119 3.61677C13.2744 2.79441 11.7996 2.79441 10.7621 3.61677L4.86582 8.3483C4.32603 8.75732 4.00665 9.3897 4 10.0626V17.9056C4 19.6146 5.39939 21 7.12562 21H8.85727C9.47412 21 9.97418 20.5049 9.97418 19.8943V19.8943"
        stroke="#1A1919"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Home;
